import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  FiCheckCircle,
  FiXCircle,
  FiArrowLeft,
  FiArrowRight,
  FiCheck,
  FiClock
} from "react-icons/fi";
import getApiBaseUrl from "../utils/api";
import FullscreenButton from "./FullscreenButton";
import IELTS_MOCK2_READING from "./ielts-mock2/readingData";
import IELTS_MOCK3_READING from "./ielts-mock3/readingData";
import IELTS_MOCK4_READING from "./ielts-mock4/readingData";
import IELTS_MOCK5_READING from "./ielts-mock5/readingData";
import IELTS_MOCK6_READING from "./ielts-mock6/readingData";
import IELTS_MOCK7_READING from "./ielts-mock7/readingData";

// --- READING DATA ---
const IELTS_DATA_READING = {
  title: "Academic Reading Test 1",
  passages: [
    {
      id: "p1",
      title: "Passage 1: The Innovation of Grocery Stores",
      text: `(A) At the beginning of the 20th century, grocery stores in the United States were full-service. A customer would ask a clerk behind the counter for specific items and the clerk would package the items, which were limited to dry goods. If they want to save some time, they have to ask a delivery boy or themselves to send the note of what they want to buy to the grocery store first and then go to pay for the goods later. These grocery stores usually carried only one brand of each good. There were early chain stores, such as the A&P Stores, but these were all entirely full-service and very time-consuming.

(B) In 1885, a Virginia boy named Clarence Saunders began working part-time as a clerk in a grocery store when he was 14 years old, and quit school when the shopkeeper offered him full-time work with room and board. Later he worked in an Alabama coke plant and in a Tennessee sawmill before he returned to the grocery business. By 1900, when he was nineteen years old, he was earning $30 a month as a salesman for a wholesale grocer. During his years working in the grocery stores, he found that it was very inconvenient and inefficient for people to buy things because more than a century ago, long before there were computers, shopping was done quite differently than it is today. Entering a store, the customer would approach the counter (or wait for a clerk to become available) and place an order, either verbally or, as was often the case for boys running errands, in the form of a note or list. While the customer waited, the clerk would move behind the counter and throughout the store, select the items on the list – some form shelves so high that a long-handled grasping device had to be used – and bring them back to the counter to be tallied and bagged or boxed. The process might be expedited by the customer calling or sending in the order beforehand, or by the order being handled by a delivery boy on a bike, but otherwise, it did not vary greatly. Saunders, a flamboyant and innovative man, noticed that this method resulted in wasted time and expense, so he came up with an unheard-of solution that would revolutionize the entire grocery industry: he developed a way for shoppers to serve themselves.

(C) So in 1902, he moved to Memphis where he developed his concept to form a grocery wholesale cooperative and a full-service grocery store. For his new "cafeteria grocery", Saunders divided his grocery into three distinct areas: 1) A front "lobby" forming an entrance and exit and checkouts at the front. 2) A sales department, which was specially designed to allow customers to roam the aisles and select their own groceries. Removing unnecessary clerks, creating elaborate aisle displays, and rearranging the store to force customers to view all of the merchandise and over the shelving and cabinets units of sales department were "galleries" where supervisors were allowed to keep an eye on the customers while not disturbing them. 3) And another section of his store is the room only allowed for the clerks which were called the "stockroom" or "storage room" where large refrigerators were situated to keep fresh products from being perishable. The new format allowed multiple customers to shop at the same time and led to the previously unknown phenomenon of impulse shopping. Though this format of grocery market was drastically different from its competitors, the style became the standard for the modern grocery store and later supermarket.

(D) On September 6, 1916, Saunders launched the self-service revolution in the USA by opening the first self-service Piggly Wiggly store, at 79 Jefferson Street in Memphis, Tennessee, with its characteristic turnstile at the entrance. Customers paid cash and selected their own goods from the shelves. It was unlike any other grocery store of that time. Inside a Piggly Wiggly, shoppers were not at the mercy of shop clerks. They were free to roam the store, check out the merchandise and get what they needed with their own two hands and feet. Prices on items at Piggly Wiggly were clearly marked. No one pressured customers to buy milk or pickles. And the biggest benefit at the Piggly Wiggly was that shoppers saved money. Self-service was positive all around. "It's good for both the consumer and retailer because it cuts costs," noted George T. Haley, a professor at the University of New Haven and director of the Center for International Industry Competitiveness. "If you looked at the way grocery stores were run previous to Piggly Wiggly and Alpha Beta, what you find is that there was a tremendous amount of labor involved, and labor is a major expense." Piggly Wiggly cut the fat.

(E) Piggly Wiggly and the self-service concept took off. Saunders opened nine stores in the Memphis area within the first year of business. Consumers embraced the efficiency, the simplicity and most of all the lower food prices. Saunders soon patented his self-service concept and began franchising Piggly Wiggly stores. Thanks to the benefits of self-service and franchising, Piggly Wiggly ballooned to nearly 1,300 stores by 1923. Piggly Wiggle sold $100 million – worth $1.3 billion today – in groceries, making it the third-biggest grocery retailer in the nation. The company's stock was even listed on the New York Stock Exchange, doubling from late 1922 to march 1923. Saunders had his hands all over Piggly Wiggly. He was instrumental in the design and layout of his stores. He even invented the turnstile.

(F) However, Saunders was forced into bankruptcy in 1923 after a dramatic spat which the New York Stock Exchange and he went on to create the "Clarence Saunders sole-owner-of-my-name" chain, which went into bankruptcy.

(G)  Until the time of his death in October 1953, Saunders was developing plans for another automatic store system called the Foodelectric. But the store, which was to be located two blocks from the first Piggly Wiggly store, never opened. But his name was well-remembered along with the name Piggly Wiggly.`,
      questions: [
{
          id: "q1_5",
          instruction: "Questions 1-5: The reading Passage has seven paragraphs, A-G. Which paragraph contains the following information?\nNB You may use any letter more than once.",
          type: "matching_paragraph",
          options: ["A", "B", "C", "D", "E", "F", "G"],
          items: [
            { id: 1, text: "How Clarence Saunders' new idea had been carried out.", answer: "D" },
            { id: 2, text: "Introducing the modes and patterns of groceries before his age.", answer: "A" },
            { id: 3, text: "Clarence Saunders declared bankruptcy a few years later.", answer: "F" },
            { id: 4, text: "Descriptions of Clarence Saunders' new conception.", answer: "C" },
            { id: 5, text: "The booming development of his business.", answer: "E" }
          ]
        },
{
  id: "q6_10",
  instruction: "Questions 6-10: Answer the questions below. Write ONLY ONE WORD AND/OR A NUMBER from the passage for each answer.",
  type: "fill_blank",
  items: [
    { 
      id: 6, 
      text: "When Clarence Saunders was an adolescent, he took a job as a ______ in a grocery store.", 
      answer: "clerk" 
    },
    { 
      id: 7, 
      text: "In the new innovation of the grocery store, most of the clerks' work before was done by _________", 
      answer: ["customers", "shoppers"]
    },
    { 
      id: 8, 
      text: "In Saunders' new grocery store, the section where customers finish the payment was called _________", 
      answer: "lobby" 
    },
{
  id: 9,
  text: "Another area in his store behind the public area was called the _________ Where only internal staff could access.",
  answer: "stockroom"
},
    { 
      id: 10, 
      text: "At _________ where customers were under surveillance.", 
      answer: "galleries" 
    }
  ]
},
        {
          id: "q11_13",
          instruction: "Questions 11-13: Choose the correct letter, A, B, C or D.",
          type: "mcq",
          items: [
{
  id: 11,
  text: "Why did Clarence Saunders want to propel the innovation of grocery stores at his age?",
  options: [
    "A.  Because he was an enthusiastic and creative man.",
    "B. Because his boss wanted to reform the grocery industry.",
    "C. Because he wanted to develop its efficiency and make a great profit as well.",
    "D. Because he worried about the future competition from the industry."
  ],
  answer: "C"
},
            {
              id: 12,
              text: " What happened to Clarence Saunders' first store of Piggly Wiggly?",
              options: [
                "A. Customers complained about its impracticality and inconvenience.",
                "B. It enjoyed a great business and was updated in the first twelve months.",
                "C. It expanded to more than a thousand franchised stores during the first year.",
                "D. Saunders was required to have his new idea patented and open stores."
              ],
              answer: "B"
            },
{
  "id": 13,
  "text": "What was left to Clarence Saunders after his death in 1953?",
  "options": [
    "A. A fully automatic store system opened soon near his first store.",
    "B. The name of his store, the Piggly Wiggly, was very popular at that time.",
    "C. His name was usually connected with his famous shop the Piggly Wiggly in the following several years.",
    "D. His name was painted together with the name of his famous store."
  ],
  "answer": "C"
}
          ]
        }
      ]
    },
    {
      id: "p2",
      title: "Passage 2: Mapping",
      text: `(A) Today, the mapmaker's vision is no longer confined to what the human eye can see. The perspective of mapmaking has shifted from the crow's nest of the sailing vessel, mountain top and airplane to 'new orbital heights. Radar, which bounces microwave radio signals off a given surface to create images of its contours and textures, can penetrate jungle foliage and has produced the first maps of the mountains of the planet Venus. And a combination of sonar and radar produces charts of the seafloor, putting much of Earth on the map for the first time. 'Suddenly it's a whole different world for us,' says Joel Morrison, chief of geography at the U.S. Bureau of the Census, 'Our future as mapmakers - even ten years from now - is uncertain.'

(B) The world's largest collection of maps resides in the basement of the Library of Congress in Washington, D.C. The collection, consisting of up to 4.6 million map sheets and 63,000 atlases, includes magnificent bound collections of elaborate maps - the pride of the golden age of Dutch cartography. In the reading room scholars, wearing thin cotton gloves to protect the fragile sheets, examine ancient maps with magnifying glasses. Across the room people sit at their computer screens, studying the latest maps. With their prodigious memories, computers are able to store data about people, places and environments - the stuff of maps - and almost instantly information is displayed on the screen in the desired geographic context, and at the click of a button, a print-out of the map appears.

(C) Measuring the spherical Earth ranks as the first major milestone in scientific cartography. This was first achieved by the Greek astronomer Eratosthenes, a scholar at the famous Alexandrian Library in Egypt in the third century BC. He calculated the Earth's circumference as 25,200 miles, which was remarkably accurate. The longitudinal circumference is known today to be 24,860 miles.

(D) Building on the ideas of his predecessors, the astronomer and geographer Ptolemy, working in the second century AD, spelled out a system for organising maps according to grids of latitude and longitude. Today, parallels of latitude are often spaced at intervals of 10 to 20 degrees and meridians at 15 degrees, and this is the basis for the width of modern time zones. Another legacy of ptolemy's is his advice to cartographers to create maps to scale. Distance on today's maps is expressed as a fraction or ratio of the real distance. But mapmakers in Ptolemy's time lacked the geographic knowledge to live up to ptolemy's scientific principles. Even now, when surveyors achieve accuracies down to inches and satellites can plot potential missile targets within feet, maps are not true pictures of reality.

(E) However, just as the compass improved navigation and created demand for useful charts, so the invention of the printing press in the 15th century put maps in the hands of more people, and took their production away from monks, who had tended to illustrate theology rather than geography. Ocean-going ships launched an age of discovery, enlarging both what could and needed to be mapped, and awakened an intellectual spirit and desire for knowledge of the world.

(F) Inspired by the rediscovered Ptolemy, whose writing had been preserved by Arabs after the sacking of the Alexandrian Library in AD 931, mapmakers in the 15th century gradually replaced theology with knowledge of faraway places, as reported by travelling merchants like Marco Polo.

(G) Gerhardus Mercator, the foremost shipmaker of the 16th century, developed a technique of arranging meridians and parallels in such a way that navigators could draw straight lines between two points and steer a constant compass course between them. This distortion formula, introduced on his world map of 1569, created the 'Greenland problem'. Even on some standard maps to this day, Greenland looks as large as South America - one of the many problems when one tries to portray a round world on a flat sheet of paper. But the Mercator projection was so practical that it is still popular with sailors.

(H) Scientific mapping of the land came into its own with the achievements of the Cassini family - father, son, grandson and great-grandson. In the late 17th century, the Italian-born founder, Jean-Dominique, invented a complex method of determining longitude based on observations of Jupiter's moons. Using this technique, surveyors were able to produce an accurate map of France. The family continued to map the French countryside and his greatgrandson finally published their famous Cassini map in 1793 during the French Revolution. While it may have lacked the artistic appeal of earlier maps, it was the model of a social and geographic map showing roads, rivers, canals, towns, abbeys, vineyards, lakes and even windmills. With this achievement, France became the first country to be completely mapped by scientific methods.

(I) Mapmaking has come a long way since those days. Today's surveyors rarely go into the field without being linked to navigation satellites. Their hand-held receivers are the most familiar of the new mapping technologies, and the satellite system, developed and still operated by the US Defense Department, is increasingly used by surveyors. Even ordinary hikers, sailors and explorers can tap into it for data telling them where they are. Simplified civilian versions of the receivers are available for a few hundred dollars and they are also the heart of electronic map displays available in some cars. Cartography is pressing on to cosmic frontiers, but its objective is, and always has been, to communicate a sense of 'here' in relation to 'there', however far away 'there' may be.`,
      questions: [
        {
          id: "q14_18",
          instruction: "Questions 14-18: Choose the correct letter A, B, C or D.",
          type: "mcq",
          items: [
            { id: 14, text: " According to the first paragraph, mapmakers in the 21st century...", options: ["A. combine techniques to chart unknown territory.", "B. still rely on being able to see what they map.", "C. are now able to visit the darkest jungle.", "D. need input from experts in other fields."], answer: "A" },
{
  id: 15,
  text: "The Library of Congress offers an opportunity to...",
  options: [
    "A. Borrow from their collection of Dutch maps.",
    "B. Learn how to restore ancient and fragile maps.",
    "C. Enjoy the atmosphere of the reading room.",
    "D. Create individual computer maps to order."
  ],
  answer: "D"
},
{
  id: 16,
  text: "Ptolemy alerted his contemporaries to the importance of...",
  options: [
    "A. Measuring the circumference of the world.",
    "B. Organising maps to reflect accurate ratios of distance.",
    "C. Working out the distance between parallels of latitude.",
    "D. Accuracy and precision in mapping."
  ],
  answer: "B"
},
{
  id: 17,
  text: "The invention of the printing press...",
  options: [
    "A. Revitalized interest in scientific knowledge.",
    "B. Enabled maps to be produced more cheaply.",
    "C. Changed the approach to mapmaking.",
    "D. Ensured that the work of Ptolemy was continued."
  ],
  answer: "C"
},
{
  id: 18,
  text: "The writer concludes by stating that...",
  options: [
    "A. Mapmaking has become too specialized.",
    "B. Cartographers work in very harsh conditions.",
    "C. The fundamental aims of mapmaking remain unchanged.",
    "D. The possibilities of satellite mapping are infinite."
  ],
  answer: "C"
}]
        },
        {
          id: "q19_21",
          instruction: "Questions 19-21: Match each achievement with the correct mapmaker.",
          type: "matching_select",
          legend: ["A. Mercator", "B. Ptolemy", "C. Cassini family", "D. Eratosthenes"],
          options: ["A", "B", "C", "D"],
          items: [
            { id: 19, text: " Came very close to accurately measuring the distance round the Earth.", answer: "D" },
            { id: 20, text: " Produced maps showing man-made landmarks.", answer: "C" },
            { id: 21, text: " Laid the foundation for our modern time zones.", answer: "B" }
          ]
        },
        {
          id: "q22_26",
          instruction: "Questions 22-26: Complete the summary (NO MORE THAN TWO WORDS).",
          type: "fill_blank",
          items: [
            { id: 22, text: " The first great step in mapmaking took place in ______ in the 3rd century BC.", answer: "Egypt" },
            { id: 23, text: " Maps were the responsibility of ______ rather than scientists.", answer: "monks" },
            { id: 24, text: " The writings of ______ had been kept.", answer: "Ptolemy" },
            { id: 25, text: " These days, ______ are vital to the creation of maps.", answer: "navigation satellites" },
 {
  id: 26,
  text: " In addition, this high-tech equipment is not only used to map faraway places but cheaper versions have also been developed for use in ______.",
  answer: "some cars"
}]
        }
      ]
    },
{
      id: "p3",
      title: "Passage 3: Communication in Science",
      text: `(A) Science plays an increasingly significant role in people's lives, making the faithful communication of scientific developments more important than ever. Yet such communication is fraught with challenges that can easily distort discussions, leading to unnecessary confusion and misunderstandings.

(B) Some problems stem from the esoteric nature of current research and the associated difficulty of finding sufficiently faithful terminology. Abstraction and complexity are not signs that a given scientific direction is wrong, as some commentators have suggested, but are instead a tribute to the success of human ingenuity in meeting the increasingly complex challenges that nature presents. They can, however, make communication more difficult. But many of the biggest challenges for science reporting arise because in areas of evolving research, scientists themselves often only partly understand the full implications of any particular advance or development. Since that dynamic applies to most of the scientific developments that directly affect people's lives – global warming, cancer research, diet studies – learning how to overcome it is critical to spurring a more informed scientific debate among the broader public.

(C) Ambiguous word choices are the source of some misunderstandings. Scientists often employ colloquial terminology, which they then assign a specific meaning that is impossible to fathom without proper training. The term "relativity," for example, is intrinsically misleading. Many interpret the theory to mean that everything is relative and there are no absolutes. Yet although the measurements any observer makes depend on his coordinates and reference frame, the physical phenomena he measures have an invariant description that transcends that observer's particular coordinates. Einstein's theory of relativity is really about finding an invariant description of physical phenomena. True, Einstein agreed with the idea that his theory would have been better named "Invarianten theorie." But the term "relativity" was already entrenched at the time for him to change.

(D) "The uncertainty principle" is another frequently abused term. It is sometimes interpreted as a limitation on observers and their ability to make measurements.

(E) But it is not about intrinsic limitations on any one particular measurement; it is about the inability to precisely measure particular pairs of quantities simultaneously. The first interpretation is perhaps more engaging from a philosophical or political perspective. It's just not what the science is about.

(F) Even the word "theory" can be a problem. Unlike most people, who use the word to describe a passing conjecture that they often regard as suspect, physicists have very specific ideas in mind when they talk about theories. For physicists, theories entail a definite physical framework embodied in a set of fundamental assumptions about the world that lead to a specific set of equations and predictions – ones that are borne out by successful predictions. Theories aren't necessarily shown to be correct or complete immediately. Even Einstein took the better part of a decade to develop the correct version of his theory of general relativity. But eventually both the ideas and the measurements settle down and theories are either proven correct, abandoned or absorbed into other, more encompassing theories.

(G) "Global warming" is another example of problematic terminology. Climatologists predict more drastic fluctuations in temperature and rainfall – not necessarily that every place will be warmer. The name sometimes subverts the debate, since it lets people argue that their winter was worse, so how could there be global warming? Clearly "global climate change" would have been a better name. But not all problems stem solely from poor word choices. Some stem from the intrinsically complex nature of much of modern science. Science sometimes transcends this limitation: remarkably, chemists were able to detail the precise chemical processes involved in the destruction of the ozone layer, making the evidence that chlorofluorocarbon gases (Freon, for example) were destroying the ozone layer indisputable.

(H) A better understanding of the mathematical significance of results and less insistence on a simple story would help to clarify many scientific discussions. For several months, Harvard was tortured by empty debates over the relative intrinsic scientific abilities of men and women. One of the more amusing aspects of the discussion was that those who believed in the differences and those who didn't use the same evidence about gender-specific special ability. How could that be? The answer is that the data shows no substantial effects. Social factors might account for these tiny differences, which in any case have an unclear connection to scientific ability. Not much of a headline when phrased that way, is it? Each type of science has its own source of complexity and potential for miscommunication. Yet there are steps we can take to improve public understanding in all cases. The first would be to inculcate greater understanding and acceptance of indirect scientific evidence. The information from an unmanned space mission is no less legitimate than the information from one in which people are on board.

(I) This doesn't mean questioning an interpretation, but it also doesn't mean equating indirect evidence with blind belief, as people sometimes suggest. Second, we might need different standards for evaluating science with urgent policy implications than research with the purely theoretical value. When scientists say they are not certain about their predictions, it doesn't necessarily mean they've found nothing substantial. It would be better if scientists were more open about the mathematical significance of their results and if the public didn't treat math as quite so scary; statistics and errors, which tell us the uncertainty in a measurement, give us the tools to evaluate new developments fairly.

(J) But most important, people have to recognize that science can be complex. If we accept only simple stories, the description will necessarily be distorted. When advances are subtle or complicated, scientists should be willing to go the extra distance to give proper explanations and the public should be more patient about the truth. Even so, some difficulties are unavoidable. Most developments reflect work in progress, so the story is complex because no one yet knows the big picture.`,
      questions: [
        {
          id: "q27_31",
          instruction: "Questions 27-31: Choose the correct letter A, B, C or D.",
          type: "mcq",
          items: [
            {
              id: 27,
              text: "Why is faithful science communication important?",
              options: [
                "A. Science plays an increasingly significant role in people's lives.",
                "B. Science is fraught with challenges the public is interested in.",
                "C. The nature of complexity in science communication leads to confusion.",
                "D. Scientific inventions are more important than ever before."
              ],
              answer: "A"
            },
            {
              id: 28,
              text: "What is the reason that the author believes is the biggest challenge for science reporting?",
              options: [
                "A. Phenomena such as global warming, cancer research, and diet studies are too complex.",
                "B. Scientists themselves often only partly understand the Theory of Evolution.",
                "C. Scientists do not comprehend the meaning of certain scientific evolution.",
                "D. Scientists themselves often only partly understand the esoteric communication nature."
              ],
              answer: "C"
            },
            {
              id: 29,
              text: "According to the 3rd paragraph, the reference to the term and example of 'theory of relativity' is to demonstrate...",
              options: [
                "A. The theory of relativity is about an invariant physical phenomenon.",
                "B. Common people may be misled by the inaccurate choice of scientific phrase.",
                "C. The term 'relativity' is designed to be misleading to the public.",
                "D. Everything is relative and there is no absolute existence."
              ],
              answer: "B"
            },
            {
              id: 30,
              text: "Which one is a good example of appropriate word choice?",
              options: [
                "A. Scientific theory for the uncertainty principle.",
                "B. Phenomenon of global warming.",
                "C. The importance of the ozone layer.",
                "D. Freon's destructive process on the environment."
              ],
              answer: "D"
            },
            {
              id: 31,
              text: "What is a surprising finding of the Harvard debates in the passage?",
              options: [
                "A. There are equal intrinsic scientific abilities of men and women.",
                "B. The proof applied by both sides seemed to be of no big difference.",
                "C. The scientific data usually shows no substantial figures to support a debated idea.",
                "D. Social factors might have a clear connection to scientific ability."
              ],
              answer: "B"
            }
          ]
        },
        {
          id: "q32_35",
          instruction: "Questions 32-35: Do the following statements agree with the information given in the passage? Write TRUE, FALSE, or NOT GIVEN.",
          type: "mcq",
          items: [
            {
              id: 32,
              text: "'Global warming' scientifically refers to greater fluctuations in temperature and rainfall rather than a universal temperature rise.",
              options: ["TRUE", "FALSE", "NOT GIVEN"],
              answer: "TRUE"
            },
            {
              id: 33,
              text: "More media coverage of 'global warming' would help the public to recognize the phenomenon.",
              options: ["TRUE", "FALSE", "NOT GIVEN"],
              answer: "NOT GIVEN"
            },
            {
              id: 34,
              text: "Harvard debates should focus more on female scientists and male scientists.",
              options: ["TRUE", "FALSE", "NOT GIVEN"],
              answer: "NOT GIVEN"
            },
            {
              id: 35,
              text: "Public understanding and acceptance of indirect scientific evidence in all cases would lead to confusion.",
              options: ["TRUE", "FALSE", "NOT GIVEN"],
              answer: "FALSE"
            }
          ]
        },
        {
          id: "q36_40",
          instruction: "Questions 36-40: Complete the summary. Use NO MORE THAN TWO WORDS from the passage for each answer.",
          type: "fill_blank",
          items: [
            { id: 36, text: "Ambiguous ______ are the source of some misunderstandings.", answer: "word choices" },
            { id: 37, text: "Common people do not understand meaning via the ______ scientists employed.", answer: "colloquial terminology" },
            { id: 38, text: "Measurements any ______ makes cannot be confined...", answer: "observer" },
            { id: 39, text: "Einstein's theory aims to find an ______ description of physical phenomena.", answer: ["invariant description", "invariant"] },
  {
  id: 40,
  text: "A good example can be the theory of ______.",
  answer: "general relativity"
}
          ]
        }
      ]
    }
  ]
};

function getFlatItems(passage) {
  const items = [];
  passage.questions.forEach(group => {
    group.items.forEach(item => items.push({ ...item, groupType: group.type, groupOptions: group.options, groupLegend: group.legend, groupInstruction: group.instruction, groupItems: group.items }));
  });
  return items;
}

// Heading for a matching group's option box ("List of Researchers" etc.).
// Uses group.legendTitle when given, otherwise reads it off the instruction.
function getLegendTitle(group) {
  if (group.legendTitle) return group.legendTitle;
  const ins = group.instruction || "";
  if (/list of headings/i.test(ins)) return "List of Headings";
  if (/list of words/i.test(ins)) return "List of Words";
  if (/correct ending/i.test(ins)) return "List of Endings";
  const m = ins.match(/with the correct ([a-z]+)/i);
  if (m) {
    const word = m[1].toLowerCase();
    const plural = word === "person" ? "people" : `${word}s`;
    return `List of ${plural.charAt(0).toUpperCase()}${plural.slice(1)}`;
  }
  return "List of Options";
}

// "A. Mercator" -> ["A", "Mercator"]; "iii. A national trial" -> ["iii", ...]
function splitLegendEntry(entry) {
  const m = entry.match(/^([A-Za-z]{1,4})\.\s+(.*)$/);
  return m ? [m[1], m[2]] : ["", entry];
}

function getPassageRange(passage) {
  const allIds = passage.questions.flatMap(g => g.items.map(i => i.id));
  return `${Math.min(...allIds)}–${Math.max(...allIds)}`;
}

function checkAnswer(userAnswerRaw, correctAnswerRaw) {
  const userAns = (userAnswerRaw || "").toString().trim().toLowerCase();

  if (!userAns) return false;

  const possibleAnswers = Array.isArray(correctAnswerRaw)
    ? correctAnswerRaw.map((a) => (a || "").toString().trim().toLowerCase())
    : (correctAnswerRaw || "").toString().trim().toLowerCase().split("/").map((a) => a.trim());

  const fullAnswer = Array.isArray(correctAnswerRaw)
    ? null
    : (correctAnswerRaw || "").toString().trim().toLowerCase();

  return possibleAnswers.includes(userAns) || userAns === fullAnswer;
}

// "Choose TWO" groups: each item's answer lists both correct letters, so either
// letter is accepted, but the same letter picked twice only scores once.
function isItemCorrect(group, item, answers) {
  if (!checkAnswer(answers[item.id], item.answer)) return false;
  if (!group || !group.chooseTwo) return true;
  const first = group.items[0];
  return item.id === first.id || answers[item.id] !== answers[first.id];
}

function getBandScore(rawScore) {
  if (rawScore >= 39) return 9.0;
  if (rawScore >= 37) return 8.5;
  if (rawScore >= 35) return 8.0;
  if (rawScore >= 33) return 7.5;
  if (rawScore >= 30) return 7.0;
  if (rawScore >= 27) return 6.5;
  if (rawScore >= 23) return 6.0;
  if (rawScore >= 19) return 5.5;
  if (rawScore >= 15) return 5.0;
  if (rawScore >= 13) return 4.5;
  if (rawScore >= 10) return 4.0;
  if (rawScore >= 8) return 3.5;
  if (rawScore >= 6) return 3.0;
if (rawScore >= 4) return 2.5;
if (rawScore >= 2) return 2.0;
if (rawScore >= 1) return 1.0;
return 0.0; 
}

const countQuestions = (data) => data.passages.reduce(
  (sum, p) => sum + p.questions.reduce((s, g) => s + g.items.length, 0),
  0
);


const TEST_DURATION_SECONDS = 60 * 60;

function formatTime(totalSeconds) {
  const safeSeconds = Math.max(0, totalSeconds);
  const minutes = Math.floor(safeSeconds / 60);
  const seconds = safeSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

export default function IeltsReading({ mock = 1 }) {
  const navigate = useNavigate();
  const READING_DATA = { 2: IELTS_MOCK2_READING, 3: IELTS_MOCK3_READING, 4: IELTS_MOCK4_READING, 5: IELTS_MOCK5_READING, 6: IELTS_MOCK6_READING, 7: IELTS_MOCK7_READING }[mock] || IELTS_DATA_READING;
  const TOTAL_QUESTIONS = countQuestions(READING_DATA);
  const [activePassage, setActivePassage] = useState(0);
  const [answers, setAnswers] = useState({});
  const [showResult, setShowResult] = useState(false);
  const [score, setScore] = useState(0);
  const [bandScore, setBandScore] = useState(0);
  const [questionAnalysis, setQuestionAnalysis] = useState([]);
  // After submitting, the score popup can be closed to review the passage
  // and questions side by side with the answers marked.
  const [showScoreModal, setShowScoreModal] = useState(false);
 
  const [focusedQId, setFocusedQId] = useState(null);
  const questionRefs = useRef({});
  // Question to focus after switching Part from the bottom nav.
  const pendingFocusRef = useRef(null);

  // Width of the passage pane in %, set by dragging the divider; remembered
  // per browser so the layout stays as the student left it.
  const [splitPct, setSplitPct] = useState(() => {
    try {
      const saved = parseFloat(localStorage.getItem("ieltsReadingSplit"));
      return saved >= 25 && saved <= 75 ? saved : 50;
    } catch {
      return 50;
    }
  });
  const splitRef = useRef(null);
  const passagePaneRef = useRef(null);
  const questionsPaneRef = useRef(null);

  useEffect(() => {
    try {
      localStorage.setItem("ieltsReadingSplit", String(splitPct));
    } catch {
      // storage unavailable (private mode) — layout just isn't remembered
    }
  }, [splitPct]);


  const [timeLeft, setTimeLeft] = useState(TEST_DURATION_SECONDS);
  const autoSubmittedRef = useRef(false);

  const API_URL = getApiBaseUrl();

  const currentPassage = READING_DATA.passages[activePassage];
  const flatItems = getFlatItems(currentPassage);

  useEffect(() => {
    const header = document.querySelector(".header");

    if (header) {
      header.style.display = "none";
    }

    return () => {
      if (header) {
        header.style.display = "flex";
      }
    };
  }, []);

 
  useEffect(() => {
    if (passagePaneRef.current) passagePaneRef.current.scrollTop = 0;
    if (questionsPaneRef.current) questionsPaneRef.current.scrollTop = 0;
    if (pendingFocusRef.current !== null) {
      setFocusedQId(pendingFocusRef.current);
      pendingFocusRef.current = null;
    } else if (flatItems.length > 0) {
      setFocusedQId(flatItems[0].id);
    }
  }, [activePassage]);


  useEffect(() => {
    if (focusedQId !== null && questionRefs.current[focusedQId]) {
      questionRefs.current[focusedQId].scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [focusedQId]);

  const handleInput = (qId, value) => {
    setAnswers(prev => ({ ...prev, [qId]: value }));
  };

  const saveTestResult = async (finalScore, totalQuestions, fullBreakdown, band, analysis) => {
    try {
      const response = await fetch(`${API_URL}/tests/save`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          testName: mock === 1 ? "IELTS Reading" : `IELTS Reading Mock ${mock}`,
          result: {
            correctAnswers: finalScore,
            incorrectAnswers: totalQuestions - finalScore,
            rawScore: finalScore,
            bandScore: band,
            total: totalQuestions,
            percentage: Math.round((finalScore / totalQuestions) * 100),
            breakdown: fullBreakdown,
            questionAnalysis: analysis
          }
        })
      });

      if (response.status === 401) {
        console.log("Not signed in — skipping save.");
        return;
      }

      const data = await response.json();
      console.log("IELTS Reading saved:", data);
    } catch (err) {
      console.error("Save failed:", err);
    }
  };

  const calculateScore = () => {
    let newScore = 0;
    let totalQuestions = 0;
    const breakdown = {};
    const analysis = [];

    READING_DATA.passages.forEach(p => {
      p.questions.forEach(group => {
        group.items.forEach(item => {
          totalQuestions++;
          const isCorrect = isItemCorrect(group, item, answers);
          if (isCorrect) newScore++;
          breakdown[item.id] = { user: answers[item.id], correct: item.answer, isCorrect };
          analysis.push({
            questionNumber: item.id,
            studentAnswer: answers[item.id] || "",
            correctAnswer: item.answer,
            isCorrect
          });
        });
      });
    });

    const band = getBandScore(newScore);

    setScore(newScore);
    setBandScore(band);
    setQuestionAnalysis(analysis);
    setShowResult(true);
    setShowScoreModal(true);
    window.scrollTo(0, 0);
    saveTestResult(newScore, totalQuestions, breakdown, band, analysis);
  };



  const calculateScoreRef = useRef(calculateScore);
  useEffect(() => {
    calculateScoreRef.current = calculateScore;
  });

  
  useEffect(() => {
    if (showResult) return; 

    if (timeLeft <= 0) {
      if (!autoSubmittedRef.current) {
        autoSubmittedRef.current = true;
        calculateScoreRef.current();
      }
      return;
    }

    const tick = setTimeout(() => {
      setTimeLeft(t => t - 1);
    }, 1000);

    return () => clearTimeout(tick);
  }, [timeLeft, showResult]);

  const isAnswered = (id) => answers[id] !== undefined && answers[id] !== "";

 
  const getResult = (item, group) => {
    if (!showResult) return null;
    return isItemCorrect(group, item, answers);
  };

  const isTimeLow = timeLeft <= 5 * 60; // last 5 minutes
  const isTimeCritical = timeLeft <= 60; // last 1 minute

  // ---------- layout helpers ----------
  const itemIds = (group) => group.items.map(i => i.id);
  const groupRange = (group) => {
    const ids = itemIds(group);
    const lo = Math.min(...ids);
    const hi = Math.max(...ids);
    return lo === hi ? `${lo}` : `${lo}-${hi}`;
  };
  // The group heading already shows "Questions 14-19", so drop that prefix.
  const stripQuestionPrefix = (text) =>
    (text || "").replace(/^Questions?\s*\d+\s*(?:[-–]\s*\d+)?\s*:\s*/i, "");
  const passageHeading = (title) => title.replace(/^(Reading\s+)?Passage\s*\d+\s*:\s*/i, "");
  const paragraphs = (text) => text.split(/\n\s*\n/).map(p => p.trim()).filter(Boolean);
  const passageItems = (passage) => passage.questions.flatMap(g => g.items);
  const groupOf = (itemId) =>
    READING_DATA.passages.flatMap(p => p.questions).find(g => g.items.some(i => i.id === itemId));
  const answeredCount = READING_DATA.passages.reduce(
    (n, p) => n + passageItems(p).filter(i => isAnswered(i.id)).length, 0
  );

  const goToQuestion = (passageIdx, itemId) => {
    if (passageIdx !== activePassage) {
      pendingFocusRef.current = itemId;
      setActivePassage(passageIdx);
    } else {
      setFocusedQId(itemId);
    }
  };

  const handleSubmit = () => {
    const left = TOTAL_QUESTIONS - answeredCount;
    if (left > 0 && !window.confirm(`You have ${left} unanswered question${left === 1 ? "" : "s"}. Submit anyway?`)) return;
    calculateScore();
  };

  // ---------- resizable divider ----------
  const startDrag = (e) => {
    e.preventDefault();
    const handle = e.currentTarget;
    handle.setPointerCapture(e.pointerId);
    const move = (ev) => {
      const rect = splitRef.current.getBoundingClientRect();
      const pct = ((ev.clientX - rect.left) / rect.width) * 100;
      setSplitPct(Math.min(75, Math.max(25, pct)));
    };
    const stop = () => {
      handle.removeEventListener("pointermove", move);
      handle.removeEventListener("pointerup", stop);
      handle.removeEventListener("pointercancel", stop);
    };
    handle.addEventListener("pointermove", move);
    handle.addEventListener("pointerup", stop);
    handle.addEventListener("pointercancel", stop);
  };
  const nudgeDivider = (e) => {
    if (e.key === "ArrowLeft") setSplitPct(p => Math.max(25, p - 2));
    if (e.key === "ArrowRight") setSplitPct(p => Math.min(75, p + 2));
  };

  // ---------- question pieces ----------
  const reviewNote = (item, group) => {
    if (!showResult) return null;
    const ok = getResult(item, group);
    const correct = Array.isArray(item.answer) ? item.answer.join(" / ") : item.answer;
    return (
      <span className={`rv-note ${ok ? "ok" : "bad"}`}>
        {ok ? <FiCheckCircle /> : <FiXCircle />}
        {!ok && <>Answer: <b>{correct}</b></>}
        {item.explanation && <span className="rv-expl">{item.explanation}</span>}
      </span>
    );
  };

  const reviewClass = (item, group) =>
    showResult ? (getResult(item, group) ? " is-correct" : " is-wrong") : "";

  const numBox = (item) => <span className="qnum-box">{item.id}</span>;

  // Text with "______" gets the blank inline; otherwise the blank follows the text.
  const withBlank = (item, blank) => {
    const parts = item.text.split("______");
    if (parts.length === 1) {
      return <>{item.text} {blank}</>;
    }
    return parts.map((part, i) => (
      <React.Fragment key={i}>
        {part}
        {i < parts.length - 1 && blank}
      </React.Fragment>
    ));
  };

  const legendLabel = (group, value) => {
    const entry = (group.legend || []).map(splitLegendEntry).find(([k]) => k === value);
    return entry ? entry[1] : value;
  };

  const dropOption = (itemId, value) => {
    if (showResult) return;
    handleInput(itemId, value);
  };

  const renderDropZone = (item, group) => {
    const value = answers[item.id];
    return (
      <span
        className={`drop-zone${focusedQId === item.id ? " active" : ""}${value ? " filled" : ""}${reviewClass(item, group)}`}
        onClick={e => { e.stopPropagation(); setFocusedQId(item.id); }}
        onDragOver={e => { if (!showResult) e.preventDefault(); }}
        onDrop={e => { e.preventDefault(); dropOption(item.id, e.dataTransfer.getData("text/plain")); }}
      >
        {numBox(item)}
        {value ? (
          <span className="drop-value">
            <b>{value}.</b> {legendLabel(group, value)}
            {!showResult && (
              <button
                type="button"
                className="drop-clear"
                aria-label={`Clear answer ${item.id}`}
                onClick={e => { e.stopPropagation(); handleInput(item.id, ""); }}
              >×</button>
            )}
          </span>
        ) : (
          <span className="drop-hint">Drop answer here</span>
        )}
      </span>
    );
  };

  const renderOptionBank = (group) => {
    const ids = itemIds(group);
    return (
      <div className="option-bank">
        <div className="option-bank-title">{getLegendTitle(group)}</div>
        {!showResult && (
          <div className="option-bank-hint">
            Drag an option into a blank, or click a blank and then click an option.
          </div>
        )}
        <div className="option-chips">
          {group.legend.map((entry, i) => {
            const [key, label] = splitLegendEntry(entry);
            return (
              <button
                type="button"
                key={i}
                className="option-chip"
                draggable={!showResult}
                disabled={showResult}
                onDragStart={e => e.dataTransfer.setData("text/plain", key)}
                onClick={() => {
                  const target = ids.includes(focusedQId) ? focusedQId : ids.find(id => !isAnswered(id));
                  if (target === undefined) return;
                  dropOption(target, key);
                  const next = ids.find(id => id !== target && !isAnswered(id));
                  if (next !== undefined) setFocusedQId(next);
                }}
              >
                <b>{key}.</b> {label}
              </button>
            );
          })}
        </div>
      </div>
    );
  };

  const renderTextInput = (item, group) => (
    <span className={`inline-blank${reviewClass(item, group)}`}>
      {numBox(item)}
      <input
        className="blank-input"
        type="text"
        value={answers[item.id] || ""}
        disabled={showResult}
        onFocus={() => setFocusedQId(item.id)}
        onChange={e => handleInput(item.id, e.target.value)}
        aria-label={`Answer ${item.id}`}
      />
    </span>
  );

  const renderSelect = (item, group) => (
    <span className={`inline-blank${reviewClass(item, group)}`}>
      {numBox(item)}
      <select
        className="blank-select"
        value={answers[item.id] || ""}
        disabled={showResult}
        onFocus={() => setFocusedQId(item.id)}
        onChange={e => handleInput(item.id, e.target.value)}
        aria-label={`Answer ${item.id}`}
      >
        <option value="">Select</option>
        {(group.options || ["A", "B", "C", "D", "E", "F", "G"]).map(opt => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
    </span>
  );

  const renderMcq = (item) => (
    <div className="mcq">
      <div className="mcq-q">{numBox(item)}<span>{item.text}</span></div>
      <div className="mcq-opts">
        {item.options.map(opt => {
          const letter = opt.charAt(0);
          const val = ["TRUE", "FALSE", "NOT GIVEN", "YES", "NO"].includes(opt) ? opt : letter;
          const selected = answers[item.id] === val;
          let review = "";
          if (showResult) {
            if (checkAnswer(val, item.answer)) review = " is-answer";
            else if (selected) review = " is-wrong";
          }
          return (
            <label key={opt} className={`mcq-opt${selected ? " sel" : ""}${review}`}>
              <input
                type="radio"
                name={`q${item.id}`}
                checked={selected}
                disabled={showResult}
                onChange={() => { setFocusedQId(item.id); handleInput(item.id, val); }}
              />
              <span>{opt}</span>
            </label>
          );
        })}
      </div>
    </div>
  );

  const renderGroup = (group) => {
    const isSummary = group.items.some(i => i.text.includes("______"));
    return (
      <section key={group.id || groupRange(group)} className="q-group">
        <h3 className="q-group-title">Questions {groupRange(group)}</h3>
        <div className="q-group-box">
          <p className="q-group-instruction">{stripQuestionPrefix(group.instruction)}</p>

          <div className={isSummary ? "q-items summary" : "q-items"}>
            {group.items.map(item => {
              let body;
              if (group.type === "mcq") body = renderMcq(item);
              else if (group.type === "fill_blank") body = withBlank(item, renderTextInput(item, group));
              else if (group.legend) body = withBlank(item, renderDropZone(item, group));
              else body = withBlank(item, renderSelect(item, group));

              return (
                <div
                  key={item.id}
                  ref={el => (questionRefs.current[item.id] = el)}
                  className={`q-item${focusedQId === item.id ? " focused" : ""}`}
                  onClick={() => setFocusedQId(item.id)}
                >
                  {body}
                  {reviewNote(item, group)}
                </div>
              );
            })}
          </div>
        </div>
        {group.legend && renderOptionBank(group)}
      </section>
    );
  };

  const partRange = getPassageRange(currentPassage).replace("–", "-");

  return (
    <div className="ielts-container">
      <style>{`
  * { box-sizing: border-box; }

  /* Pinned below the site navbar so only the two panes scroll. */
  .ielts-container {
    position: fixed;
    top: var(--tx-nav-h, 84px);
    left: 0; right: 0; bottom: 0;
    z-index: 1;
    overflow: clip;
    background: #fff;
    color: #111;
    font-family: "Segoe UI", Roboto, Arial, sans-serif;
    display: flex;
    flex-direction: column;
  }

  /* TOP BAR */
  .rd-topbar {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    border-bottom: 1px solid #e5e7eb;
    flex-shrink: 0;
  }
  .rd-topbar-left { display: flex; align-items: center; gap: 10px; min-width: 0; }
  .rd-crumb { font-size: 0.85rem; color: #555; cursor: pointer; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .rd-crumb:hover { text-decoration: underline; }
  .rd-timer { display: flex; align-items: center; gap: 6px; font-weight: 700; font-size: 0.95rem; font-variant-numeric: tabular-nums; }
  .rd-timer.low { color: #b45309; }
  .rd-timer.critical { color: #dc2626; animation: rd-pulse 1s infinite; }
  @keyframes rd-pulse { 50% { opacity: 0.5; } }
  .rd-topbar-right { display: flex; justify-content: flex-end; align-items: center; gap: 8px; }
  .review-score { font-weight: 700; color: #15803d; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 999px; padding: 4px 12px; font-size: 0.82rem; white-space: nowrap; }

  /* PART HEADER */
  .rd-part-head {
    margin: 8px 10px;
    padding: 6px 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    background: #f9fafb;
    flex-shrink: 0;
  }
  .rd-part-head b { font-size: 0.95rem; }
  .rd-part-head div { font-size: 0.82rem; color: #333; }

  /* SPLIT PANES */
  .rd-split { flex: 1; min-height: 0; display: flex; margin: 0 10px; position: relative; }
  .rd-pane { min-width: 0; overflow-y: auto; scrollbar-width: thin; }
  .rd-passage { padding: 10px 18px 70px 8px; }
  .rd-questions { flex: 1; padding: 10px 8px 24px 18px; }
  .rd-divider {
    flex: 0 0 12px;
    cursor: col-resize;
    position: relative;
    touch-action: none;
    outline: none;
  }
  .rd-divider::before {
    content: "";
    position: absolute;
    top: 0; bottom: 0; left: 5px;
    width: 2px;
    background: #d1d5db;
  }
  .rd-divider:hover::before, .rd-divider:focus-visible::before { background: #16a34a; }
  .rd-divider-grip {
    position: absolute;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    width: 26px; height: 22px;
    border: 1px solid #111;
    border-radius: 3px;
    background: #fff;
    display: flex; align-items: center; justify-content: center;
    font-size: 13px; font-weight: 700;
    user-select: none;
  }

  /* PASSAGE */
  .rd-passage-intro { font-style: italic; font-size: 0.92rem; margin: 6px 0 18px; }
  .rd-passage-title { font-size: 1.1rem; font-weight: 700; margin: 0 0 14px; }
  .rd-passage p { font-size: 0.97rem; line-height: 1.9; margin: 0 0 16px; }

  /* QUESTION GROUPS */
  .q-group { margin-bottom: 34px; }
  .q-group-title { font-size: 1.15rem; font-weight: 500; margin: 6px 0 10px; }
  .q-group-box { border: 1px solid #d1d5db; border-radius: 3px; padding: 12px 14px; }
  .q-group-instruction { margin: 0 0 14px; font-size: 0.95rem; white-space: pre-line; }
  .q-items { display: flex; flex-direction: column; gap: 14px; }
  .q-items.summary { gap: 10px; }
  .q-item { font-size: 0.95rem; line-height: 2.3; border-radius: 4px; padding: 0 4px; scroll-margin: 20px; }
  .q-item.focused { background: #f0fdf4; }

  .qnum-box {
    display: inline-flex; align-items: center; justify-content: center;
    min-width: 24px; height: 24px; padding: 0 4px;
    border: 1.5px solid #111; border-radius: 2px;
    font-weight: 700; font-size: 0.85rem; line-height: 1;
    margin-right: 6px; background: #fff;
  }

  /* text blank */
  .inline-blank { display: inline-flex; align-items: center; vertical-align: middle; margin: 0 4px; }
  .blank-input, .blank-select {
    height: 28px; min-width: 140px; max-width: 220px;
    border: 1px solid #9ca3af; border-radius: 3px; padding: 0 8px;
    font-size: 0.9rem; font-family: inherit; background: #fff; color: #111;
  }
  .blank-select { min-width: 90px; }
  .blank-input:focus, .blank-select:focus { outline: none; border-color: #16a34a; box-shadow: 0 0 0 2px rgba(22,163,74,.2); }
  .inline-blank.is-correct .blank-input, .inline-blank.is-correct .blank-select { border-color: #16a34a; background: #f0fdf4; }
  .inline-blank.is-wrong .blank-input, .inline-blank.is-wrong .blank-select { border-color: #ef4444; background: #fef2f2; }

  /* drag-and-drop blank */
  .drop-zone {
    display: inline-flex; align-items: center; vertical-align: middle;
    min-width: 150px; min-height: 30px; margin: 0 4px; padding: 2px 6px 2px 3px;
    border: 1px dashed #9ca3af; border-radius: 3px; cursor: pointer; line-height: 1.4;
    background: #fff;
  }
  .drop-zone.active { border-color: #16a34a; border-style: solid; box-shadow: 0 0 0 2px rgba(22,163,74,.2); }
  .drop-zone.filled { border-style: solid; }
  .drop-zone.is-correct { border-color: #16a34a; background: #f0fdf4; }
  .drop-zone.is-wrong { border-color: #ef4444; background: #fef2f2; }
  .drop-hint { font-size: 0.72rem; font-style: italic; color: #888; }
  .drop-value { font-size: 0.9rem; display: inline-flex; align-items: center; gap: 4px; }
  .drop-clear { border: none; background: none; cursor: pointer; font-size: 1rem; color: #888; padding: 0 2px; }
  .drop-clear:hover { color: #dc2626; }

  /* option bank (drag source) */
  .option-bank { margin-top: 10px; border: 1px solid #e5e7eb; border-radius: 3px; padding: 10px 12px; background: #fafafa; }
  .option-bank-title { font-weight: 700; font-size: 0.9rem; margin-bottom: 2px; }
  .option-bank-hint { font-size: 0.75rem; font-style: italic; color: #555; margin-bottom: 8px; }
  .option-chips { display: flex; flex-wrap: wrap; gap: 6px; }
  .option-chip {
    border: 1px solid #d1d5db; border-radius: 3px; background: #fff;
    padding: 5px 9px; font-size: 0.88rem; font-family: inherit; color: #111;
    cursor: grab; text-align: left;
  }
  .option-chip:hover:not(:disabled) { border-color: #16a34a; background: #f0fdf4; }
  .option-chip:disabled { cursor: default; color: #333; }
  .option-chip b { font-weight: 600; margin-right: 2px; }

  /* MCQ / TFNG */
  .mcq-q { display: flex; align-items: flex-start; line-height: 1.6; }
  .mcq-opts { display: flex; flex-direction: column; gap: 2px; margin: 6px 0 0 30px; }
  .mcq-opt { display: flex; align-items: center; gap: 8px; line-height: 1.5; padding: 3px 8px; border-radius: 3px; cursor: pointer; border: 1px solid transparent; }
  .mcq-opt:hover { background: #f3f4f6; }
  .mcq-opt.sel { background: #f0fdf4; }
  .mcq-opt.is-answer { border-color: #16a34a; background: #f0fdf4; }
  .mcq-opt.is-wrong { border-color: #ef4444; background: #fef2f2; }
  .mcq-opt input { accent-color: #16a34a; margin: 0; }

  /* review notes */
  .rv-note { display: inline-flex; align-items: center; flex-wrap: wrap; gap: 4px; margin-left: 6px; font-size: 0.82rem; line-height: 1.5; }
  .rv-note.ok { color: #16a34a; }
  .rv-note.bad { color: #b91c1c; }
  .rv-expl { flex-basis: 100%; color: #444; font-style: italic; }

  /* FLOATING PART ARROWS + SUBMIT */
  .rd-arrows { position: absolute; left: 0; bottom: 8px; display: flex; gap: 4px; z-index: 5; }
  .rd-arrow { width: 30px; height: 30px; border: none; border-radius: 3px; background: #222; color: #fff; display: flex; align-items: center; justify-content: center; cursor: pointer; }
  .rd-arrow:disabled { opacity: 0.3; cursor: default; }
  .rd-submit { position: absolute; right: 8px; bottom: 8px; z-index: 5; }

  .btn-primary {
    background: #16a34a; color: #fff; font-weight: 700; border: none; border-radius: 4px;
    padding: 7px 14px; cursor: pointer; font-size: 0.88rem; display: inline-flex; align-items: center; gap: 6px;
  }
  .btn-primary:hover { background: #15803d; }
  .btn-ghost {
    background: #fff; color: #15803d; border: 1px solid #bbf7d0; border-radius: 4px;
    padding: 6px 12px; cursor: pointer; font-size: 0.85rem; white-space: nowrap;
  }
  .btn-ghost:hover { background: #f0fdf4; }

  /* BOTTOM PART NAV */
  .rd-nav { display: flex; gap: 6px; padding: 6px 10px 8px; border-top: 1px solid #e5e7eb; flex-shrink: 0; }
  .rd-nav-part {
    flex: 1; min-width: 0; border: 1px solid #e5e7eb; border-radius: 3px; background: #fff;
    padding: 6px 8px; display: flex; align-items: center; justify-content: center; gap: 6px;
    cursor: pointer; font-family: inherit; font-size: 0.88rem; color: #111;
  }
  .rd-nav-part.active { flex: 1.6; border-color: #fca5a5; cursor: default; flex-wrap: wrap; }
  .rd-nav-part em { color: #444; }
  .rd-nav-num {
    min-width: 22px; height: 22px; padding: 0 3px; border: 1px solid #111; border-radius: 2px; background: #fff;
    font-size: 0.75rem; font-family: inherit; cursor: pointer; color: #111;
  }
  .rd-nav-num.answered { background: #111; color: #fff; }
  .rd-nav-num.current { outline: 2px solid #16a34a; outline-offset: 1px; }
  .rd-nav-num.correct { background: #16a34a; border-color: #16a34a; color: #fff; }
  .rd-nav-num.wrong { background: #ef4444; border-color: #ef4444; color: #fff; }

  /* RESULT MODAL */
  .result-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.5); backdrop-filter: blur(6px); z-index: 200; display: flex; align-items: center; justify-content: center; padding: 16px; }
  .result-modal { background: #fff; border: 1px solid #bbf7d0; border-radius: 16px; padding: 2.2rem 2.5rem; text-align: center; box-shadow: 0 20px 60px rgba(0,0,0,.15); min-width: 280px; }

  /* NARROW SCREENS: stack passage over questions, no divider */
  @media (max-width: 860px) {
    .rd-split { flex-direction: column; overflow-y: auto; }
    .rd-pane { flex: none !important; width: auto !important; overflow: visible; }
    .rd-passage { padding: 8px 4px 20px; border-bottom: 2px solid #e5e7eb; }
    .rd-questions { padding: 16px 4px 70px; }
    .rd-divider { display: none; }
    .rd-arrows, .rd-submit { position: fixed; }
    .rd-arrows { left: 10px; bottom: 64px; }
    .rd-submit { right: 10px; bottom: 64px; }
    .rd-nav-part:not(.active) { flex: 0 0 auto; }
    .rd-nav-part:not(.active) em { display: none; }
    .rd-crumb { display: none; }
  }
      `}</style>

      {/* RESULT OVERLAY */}
      {showResult && showScoreModal && (
        <div className="result-overlay">
          <div className="result-modal">
            <h2 style={{ fontSize: "1.5rem", fontWeight: 700, marginBottom: "0.5rem" }}>Test Complete!</h2>
            <div style={{ fontSize: "3.2rem", fontWeight: 800, color: "#16a34a", lineHeight: 1.1 }}>
              {score} <span style={{ fontSize: "1.3rem", color: "#888" }}>/ {TOTAL_QUESTIONS}</span>
            </div>
            <div style={{ fontSize: "1.3rem", fontWeight: 700, color: "#15803d", marginTop: "0.35rem" }}>
              Band {bandScore.toFixed(1)}
            </div>
            <p style={{ color: "#888", margin: "0.5rem 0 1.4rem", fontSize: "0.9rem" }}>
              {timeLeft <= 0 ? "Time's up! " : ""}Your performance has been saved
            </p>
            <div style={{ display: "flex", gap: "10px", justifyContent: "center", flexWrap: "wrap" }}>
              <button className="btn-primary" onClick={() => { goToQuestion(0, passageItems(READING_DATA.passages[0])[0].id); setShowScoreModal(false); }}>
                Review Answers
              </button>
              <button className="btn-ghost" onClick={() => navigate("/profile")}>
                Go to Profile
              </button>
            </div>
          </div>
        </div>
      )}

      {/* TOP BAR */}
      <div className="rd-topbar">
        <div className="rd-topbar-left">
          <FullscreenButton />
          <span className="rd-crumb" onClick={() => navigate("/tests/ielts")}>
            {mock === 1 ? "IELTS Mock Test" : `IELTS Mock Test ${mock}`} / Reading
          </span>
        </div>
        {showResult ? (
          <span className="review-score">
            Review · {score}/{TOTAL_QUESTIONS} · Band {bandScore.toFixed(1)}
          </span>
        ) : (
          <div
            className={`rd-timer${isTimeCritical ? " critical" : isTimeLow ? " low" : ""}`}
            title="Time remaining"
          >
            <FiClock />
            {formatTime(timeLeft)}
          </div>
        )}
        <div className="rd-topbar-right">
          {showResult && (
            <button className="btn-ghost" onClick={() => navigate("/profile")}>Go to Profile</button>
          )}
        </div>
      </div>

      {/* PART HEADER */}
      <div className="rd-part-head">
        <b>Part {activePassage + 1}</b>
        <div>Read the text and answer questions {partRange}</div>
      </div>

      {/* SPLIT PANES */}
      <div className="rd-split" ref={splitRef}>
        <div className="rd-pane rd-passage" ref={passagePaneRef} style={{ flex: `0 0 ${splitPct}%`, width: `${splitPct}%` }}>
          <p className="rd-passage-intro">
            You should spend about 20 minutes on Questions {partRange}, which are based on Reading Passage {activePassage + 1} below.
          </p>
          <h2 className="rd-passage-title">{passageHeading(currentPassage.title)}</h2>
          {paragraphs(currentPassage.text).map((para, i) => <p key={i}>{para}</p>)}
        </div>

        <div
          className="rd-divider"
          role="separator"
          aria-orientation="vertical"
          aria-label="Resize passage and questions"
          aria-valuenow={Math.round(splitPct)}
          aria-valuemin={25}
          aria-valuemax={75}
          tabIndex={0}
          onPointerDown={startDrag}
          onKeyDown={nudgeDivider}
          onDoubleClick={() => setSplitPct(50)}
          title="Drag to resize (double-click to reset)"
        >
          <span className="rd-divider-grip">↔</span>
        </div>

        <div className="rd-pane rd-questions" ref={questionsPaneRef}>
          {currentPassage.questions.map(renderGroup)}
        </div>

        <div className="rd-arrows">
          <button
            className="rd-arrow"
            aria-label="Previous part"
            disabled={activePassage === 0}
            onClick={() => setActivePassage(p => Math.max(0, p - 1))}
          ><FiArrowLeft /></button>
          <button
            className="rd-arrow"
            aria-label="Next part"
            disabled={activePassage === READING_DATA.passages.length - 1}
            onClick={() => setActivePassage(p => Math.min(READING_DATA.passages.length - 1, p + 1))}
          ><FiArrowRight /></button>
        </div>

        {!showResult && (
          <div className="rd-submit">
            <button className="btn-primary" onClick={handleSubmit}>Submit <FiCheck /></button>
          </div>
        )}
      </div>

      {/* BOTTOM PART NAV */}
      <nav className="rd-nav" aria-label="Parts and questions">
        {READING_DATA.passages.map((p, pIdx) => {
          const items = passageItems(p);
          if (pIdx !== activePassage) {
            const summary = showResult
              ? `${items.filter(i => getResult(i, groupOf(i.id))).length}/${items.length} correct`
              : `${items.filter(i => isAnswered(i.id)).length} of ${items.length} answered`;
            return (
              <button key={p.id || pIdx} className="rd-nav-part" onClick={() => setActivePassage(pIdx)}>
                <b>Part {pIdx + 1}:</b> <em>{summary}</em>
              </button>
            );
          }
          return (
            <div key={p.id || pIdx} className="rd-nav-part active">
              <b>Part {pIdx + 1}:</b>
              {items.map(i => {
                let cls = "rd-nav-num";
                if (showResult) cls += getResult(i, groupOf(i.id)) ? " correct" : " wrong";
                else if (isAnswered(i.id)) cls += " answered";
                if (focusedQId === i.id) cls += " current";
                return (
                  <button key={i.id} className={cls} onClick={() => goToQuestion(pIdx, i.id)} aria-label={`Question ${i.id}`}>
                    {i.id}
                  </button>
                );
              })}
            </div>
          );
        })}
      </nav>
    </div>
  );
}
